import { amplifyProxy, directApi } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    submittedDeductionRecords: '',
    loading: {
      records: false,
      download: false,
      authorize: false,
      reject: false,
      archive: false
    },
    error: {
      records: null,
      download: null,
      authorize: null,
      reject: null,
      archive: null
    }
  },
  mutations: {
    SET_SUBMITTED_DEDUCTIONS(state, data) {
      state.submittedDeductionRecords = data
    },
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value
    },
    SET_ERROR(state, { type, error }) {
      state.error[type] = error
    }
  },
  actions: {
    async downloadDocument({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'download', value: true })
      commit('SET_ERROR', { type: 'download', error: null })

      try {
        await directApi.downloadDocument(
          rootState.user.ClientName,
          payload.documentID,
          payload.filename,
          rootState.user.LoginToken
        )
        // directApi handles the complete download, including cleanup
        return { success: true }
      } catch (error) {
        commit('SET_ERROR', { type: 'download', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'download', value: false })
      }
    },

    async getSubmittedDeductionRecords({ commit, rootState }) {
      commit('SET_LOADING', { type: 'records', value: true })
      commit('SET_ERROR', { type: 'records', error: null })

      try {
        const response = await amplifyProxy.get(`/${rootState.user.ClientName}/contractors/deductions`, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        commit('SET_SUBMITTED_DEDUCTIONS', response.data.Data)
        return response.data.Data
      } catch (error) {
        commit('SET_ERROR', { type: 'records', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'records', value: false })
      }
    },

    async authoriseContractorInvoice({ commit, rootState }, deductionID) {
      commit('SET_LOADING', { type: 'authorize', value: true })
      commit('SET_ERROR', { type: 'authorize', error: null })

      try {
        const response = await amplifyProxy.post(`/${rootState.user.ClientName}/contractors/deductions/${deductionID}/authorise`, {}, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'authorize', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'authorize', value: false })
      }
    },

    async rejectContractorInvoice({ commit, rootState }, deductionID) {
      commit('SET_LOADING', { type: 'reject', value: true })
      commit('SET_ERROR', { type: 'reject', error: null })

      try {
        const response = await amplifyProxy.post(`/${rootState.user.ClientName}/contractors/deductions/${deductionID}/reject`, {}, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'reject', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'reject', value: false })
      }
    },

    async archiveContractorInvoice({ commit, rootState }, deductionID) {
      commit('SET_LOADING', { type: 'archive', value: true })
      commit('SET_ERROR', { type: 'archive', error: null })

      try {
        const response = await amplifyProxy.post(`/${rootState.user.ClientName}/contractors/deductions/${deductionID}/archive`, {}, {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID
          }
        })
        return response
      } catch (error) {
        commit('SET_ERROR', { type: 'archive', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'archive', value: false })
      }
    }
  }
}